import BaseRestApi from "../BaseRestApi";
import restEndpoints from "../restEndPointURLs";

const _preparePath = () => restEndpoints.CREATE_POLICY;

class CreatePolicyApi extends BaseRestApi.Api {
    constructor() {
        super({
            getPath: _preparePath,
            method: BaseRestApi.methods.POST,
            getRequestPayload: (data) => data,
        });
    }
}

export default new CreatePolicyApi();
